import { Route } from "vue-router";
import store from "@/store";
import { safeGetItem } from "@/helpers/safeLocalStorage";

export const redirectMfaVerify = async function(
  this: any,
  toRoute: Route,
  fromRoute: Route,
  next: any
): Promise<void> {
  // If not login path, continue
  if (!toRoute.path.includes("/mfa/verify")) {
    return next();
  }

  const hasToken = safeGetItem("auth_mfa_verify");
  if (!hasToken) {
    return next("/login");
  }

  try {
    await store.dispatch("auth/authCheckMfaVerify");
    return next();
  } catch (error) {
    return next("/login");
  }
};
